import React, {useRef, useState, useEffect, Fragment } from "react";
import Layout from "components/layout/Layout";
import localization from "assets/localization/localization";
// import moment from "moment";
import { BaseUrl } from "context/baseUrl/baseUrl";
import { Link, useHistory } from "react-router-dom";
// import { checkEmpty,dateParser, statusToTextActiveInactive } from "services/utils/commonFunctions/CommonFunctions";
import FormSection from "components/form/FormSection";
import Images from "assets/images/imageData";
import Loader from "components/loader/loader";
import { trim } from "lodash";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
// import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import Form from 'react-bootstrap/Form'
import callWebService, { callTypes }  from "services/utils/networks/network";
import Config from "services/config/config";
import "./DMS.scss";
import MainLayout from "components/mainLayout/MainLayout";
// import  ConstVar from "constants/const";
import DropdownFilter from "components/input/dropdown/dropDownFilter";

const DMS = ({ match }) => {
  const [smallModal, setSmallModal] = useState({hover1: false, hover2: false, show: false});
  const [activeComponent, setActiveComponent] = useState();
  // const history = useHistory();
  const scrl = useRef(null);

  const [isLoading, setisLoading] = useState(true);
  const [pageNo,setPageNo]= useState(1);
  const [show, setShow] = useState(false);
  const [perPageRecord, setPerPageRecord] = useState(10)
  const [totalRecord, setTotalRecord] = useState(0);
  // const [partnerName, setPartnerName] = useState("");
  const [searchName, setSearchName] = useState("");
  const [dmsData,setDMSData]=useState([]);
  const [documentData, setDocumentData] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [isEditDms, setIsEditDms] = useState(false);
  const [addDmsData, setAddDmsData] = useState({
    documentName: "",
    applicantName: "",
    dmsCode: "",
    dmsMappingId: ""
  });

  const [editDmsData, setEditDmsData] = useState({});
  const [errMsg, setErrMsg] = useState({
    documentName: "",
    applicantName: "",
    dmsCode: "",
  });

  const [applicantList, setApplicantList] = useState([
    { applicantId: 0, applicantName: "Main Applicant" },
    { applicantId: 1, applicantName: "Co-applicant 1" },
    { applicantId: 2, applicantName: "Co-applicant 2" },
    { applicantId: 3, applicantName: "Co-applicant 3" },
    { applicantId: 4, applicantName: "Co-applicant 4" },
    ]);

    useEffect(() => {

      async function check() {

        const data={
          searchName: "",
          pageSize: 50,
        }
        const res = await callWebService(
          callTypes.post,
          data,
          Config.documentList
        );
        
        if(res?.data?.data?.documentTypes){
          let documentObj = [];
          const abs = res?.data?.data?.documentTypes.forEach((data) => {
          let ab = {
              documentId: data.id,
              documentName: data.name
            };
            return ab
          });
            setDocumentData(res?.data?.data?.documentTypes);
        }
      }
      check()
    }, []);

  const recordsPerPage = [
    {records_id: 10, records_value: 10},
    {records_id: 20, records_value: 20},
    {records_id: 30, records_value: 30},
    {records_id: 50, records_value: 50}
  ];

  const handleAscendingOrder = () => {

  }

  const handleDescendingOrder = () => {
    
  }

  const renderHeader = () => {
    let headerElement = [
      "S. No.",
      "Document Name",
      "Document Code",
      "Applicant Number",
      "Doc Format",
      "Type Code",
      "Action"
    ];

    return headerElement.map((key, index) => {
      if (key === "Applicant Name" || key === "Order Date"){
        return(
          <th>
            {key}
            &nbsp;
            <div>
            <button
              className="btn-sorting"
              type="button"
              onClick={() => handleAscendingOrder()}
            >
              <img src={Images?.stickUpArrow} alt="" />    
            </button>
            <button
              className="btn-sorting"
              type="button"
              aria-haspopup="true"
              aria-expanded="false"
              onClick={() => handleDescendingOrder()}
            >
              <img src={Images?.stickDownArrow} alt="" />    
            </button>
            </div>
          </th>
        );
      }
      else {
        return <th key={index}>{key}</th>;
      }
    });
  };


  const handleClose = () => {
    setAddDmsData({
      documentName: "",
      applicantName: "",
      dmsCode: "",
      dmsMappingId: ""
    });
    setErrMsg({
      documentName: "",
      applicantName: "",
      dmsCode: "",
    });
    setIsEditDms(false)
    setShow(false);
    setSuccessMsg("");
  }
  const handleShow = () => setShow(true);

  const dmsChange = (e) => {
    const { name, value } = e.target;
    setAddDmsData((state) => ({ ...state, [name]: value }));
  }

  const handleSubmit = async () => {
    if (addDmsData.documentName === '') {
      setErrMsg((state) => ({ ...state, documentName: "Enter document name" }));
      return;
    } else {
      setErrMsg((state) => ({ ...state, documentName: "" }));
    }
    
    if (addDmsData.applicantName === '') {
      setErrMsg((state) => ({ ...state, applicantName: "Enter applicant name" }));
      return;
    } else {
      setErrMsg((state) => ({ ...state, applicantName: "" }));
    } 
    if (addDmsData.dmsCode === '') {
      setErrMsg((state) => ({ ...state, dmsCode: "Enter dms code" }));
      return;
    } {
      setErrMsg((state) => ({ ...state, dmsCode: "" }));
    }


    setIsSubmit(true);
    const dataObj = {
      documentTypeId: addDmsData.documentName,
      applicantSrNo: addDmsData.applicantName,
      dmsTypeId: addDmsData.dmsCode,
      dmsMappingId: addDmsData.dmsMappingId
    }
    const res= await callWebService(
      callTypes.post,
      dataObj,
      Config.addDms
    );
    if (res.data.code === 200 || res.data.code === true) {  
      setErrorMsg("");
      setSuccessMsg(res.data.message);
      setAddDmsData({
        documentName: "",
        applicantName: "",
        dmsCode: "",
        dmsMappingId: ""
      });
      setErrMsg({
        documentName: "",
        applicantName: "",
        dmsCode: "",
      });
      setIsSubmit(false);
      setTimeout(() => {
        document.location.reload();
      }, 500)
    }else {
      setIsSubmit(false);
      setSuccessMsg("");
      setErrorMsg(res.data.data[0].message);
    }
  }

    //edit partner
    const editDmsDetail = (data) => {
      console.log('edit dms data', data)
      setShow(true);
      setIsEditDms(true)
      setEditDmsData(data)
      const dataObj = {
        documentName: data.document_type_id,
        applicantName: data.applicant_sr_no?.toString(),
        dmsCode: data.dms_id,
        dmsMappingId: data.id
      }

      setAddDmsData(dataObj)
    }

  const inputSearch = () => {
    return (
      <>
      <div style={{display: "inline-block"}}>
        <input
          type="text"
          className="search-button"
          name="search"
          value={searchName}
          placeholder="Document Name/Code"
          onChange={(e) => setSearchName(e.target.value)}
        />
        &nbsp;<button className="btn btn-primary" onClick={()=> searchDocuent()} >Search</button>
        &nbsp;<button className="btn btn-warning" onClick={()=> resetDocument()} >Reset</button>        
      </div>
        <div style={{float:"right", position: 'relative'}}>
        {dmsData && dmsData.length > 0 ?
          <b className="pagination-value" data-hovered={smallModal.hover1} style={{cursor: 'pointer'}} onMouseLeave={() => {
            setSmallModal({...smallModal, hover1: false, hover2: false});
          }} onMouseEnter={() => {
            setSmallModal({...smallModal, hover1: true, show: true});
          }}
          >{pageNo == 1 ? pageNo : (pageNo-1)*perPageRecord + 1}-{pageNo*perPageRecord > totalRecord ? totalRecord : pageNo*perPageRecord} of {totalRecord}</b> : <span className="pagination-value">0 - 0 of 0</span>}&nbsp;
          {(smallModal.hover1) && <div className="small-modal" onMouseEnter={() => {
            setSmallModal({...smallModal, hover2: true})
          }} onMouseLeave={() => {
            setSmallModal({...smallModal, hover2: false, hover1: false});
          }}>
              <span className="small-modal-option" data-disabled={pageNo === 1 && true} onClick={() => {
                nextPage(1);
              }}>Newest</span>
              <span className="small-modal-option" data-disabled={totalRecord <= pageNo*perPageRecord && true} onClick={() => {
                nextPage((Math.ceil(totalRecord / perPageRecord)));
              }}>Oldest</span>
            </div>}
        <button
          className="pagination-button"
          onClick={() => nextPage(pageNo-1)}
          title="Newer"
          data-disabled={pageNo <= 1 && true}
          disabled={pageNo <= 1}
        >
          {"<"}
        </button>&nbsp;
        <button
          className="pagination-button"
          onClick={() => nextPage(pageNo+1)}
          title="Older"
          data-disabled={totalRecord <= pageNo*perPageRecord || dmsData.length === 0}
          disabled={totalRecord <= pageNo*perPageRecord || dmsData.length === 0}
        >
          {">"}
        </button>
      </div>&nbsp;&nbsp;
      &nbsp;<button style={{float:"right"}} className="btn btn-primary mr-2" onClick={()=> handleShow()} >Add DMS</button> &nbsp; &nbsp;
    </>
    );
  };

  const nextPage = async (page) => {
    setisLoading(true);
    dmsApi(page);
    setisLoading(false);
  }

  const searchDocuent = () => {
    setPageNo(1);
    dmsApi(1);
  }

  const resetDocument = () => {
    setSearchName("");
    window.location.reload();
  }

  useEffect(()=>{
    (async () => {
    dmsApi(1);
   })();
  },[])

  const dmsApi = async (page) => {
    setisLoading(true);
    const data={
      searchName:searchName !== "" ? trim(searchName) : "",
      pageNo:page ? page : 1,
      pageSize: perPageRecord,
    }
    // const res=await dmsMappingList(data);
    const res = await callWebService(
      callTypes.post,
      data,
      Config.dmsMapping
    );
    if(res?.data?.data){
        setisLoading(false)
        setDMSData(res?.data?.data?.documentTypes);
        setPerPageRecord(res?.data?.data?.pagination?.pre_page_records);
        setTotalRecord(res?.data?.data?.pagination?.total_rows);
        setPageNo(page ? page : res?.data?.data?.pagination?.current_page);
        setisLoading(false);
    }
    setisLoading(false);
  }

  const handleRecordsPerPage = async (event) => {
    setPageNo(1);
    setisLoading(true);
    const data={
      searchName:searchName !== "" ? trim(searchName) : "",
      pageNo: 1,
      pageSize: parseInt(event.target.value),
    }
    // const res=await dmsMappingList(data);
    const res = await callWebService(
      callTypes.post,
      data,
      Config.dmsMapping
    );
    if(res?.data?.data){
        setDMSData(res?.data?.data?.documentTypes);
        setPerPageRecord(res?.data?.data?.pagination?.pre_page_records);
        setTotalRecord(res?.data?.data?.pagination?.total_rows);
        setisLoading(false);
    }
  };

  return (
    <BaseUrl.Provider value={{ baseUrl: match.url }}>
      <MainLayout
        activeComponent={activeComponent}
        match={match}
      >
        <Layout
          title={localization.dmsMapping}
          isLoading={false}
          isGoback={true}
          className={"desktop-view"}
        >
           {inputSearch()}
          <FormSection
          >
            <div className="panel-card-table" ref={scrl}>
              <table id="employee" className="table table-bordered">
                <thead>
                  <tr>{renderHeader()}
                  </tr>
                </thead>
                <tbody>
                  {dmsData && dmsData.map((data, idx) => (
                    <tr key={idx}>
                    <td>{pageNo === 1 ? idx + 1 : (pageNo - 1) * perPageRecord + idx + 1}</td>
                    <td>{data.name} </td>
                    <td>{data.code}</td>
                    <td>{data.applicant_sr_no}</td>
                    <td>{data.doc_format?.toString()}</td> 
                    <td>{data.dms_id}</td>    
                    <td><button className="btn btn-success" onClick={() => editDmsDetail(data)}>Edit</button></td>         
                  </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{maxWidth: '150px'}}>
              <DropdownFilter
                  optIdKey="records_id"
                  optValueKey="records_value"
                  optionList={recordsPerPage}
                  placeholder="Records Per Page"
                  onChange={(event) => {
                    setPerPageRecord(event.target.value);
                    handleRecordsPerPage(event);
                  }}
                  value={perPageRecord}
               />
            </div>
          </FormSection>
          <Loader isLoading={isLoading} />
        <Modal className="dms-modal" show={show} onHide={handleClose}>
        <Modal.Header closeButton style={{backgroundColor: "#f7fcfd"}}>
          <Modal.Title >{isEditDms ? "Edit" : "Add" } DMS Mapping
            <br/><span style={{color: successMsg ? "green" : "red", fontSize: "small"}}>{successMsg ? successMsg : errorMsg}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{textAlign: ""}}>
              <Col>
                <label>Document Name</label>
                <DropdownFilter 
                  optIdKey="id"
                  optValueKey="name"
                  optionList={documentData}
                  placeholder="Document Name"
                  name="documentName"
                  onChange={(e) => dmsChange(e)}
                  value={addDmsData.documentName}
                />
                <span style={{color:"red"}}>{errMsg.documentName}</span>
              </Col>
              <Col>
                <label>Applicant Name</label>
                <DropdownFilter 
                    optIdKey="applicantId"
                    optValueKey="applicantName"
                    optionList={applicantList}
                    placeholder="Applicant Name"
                    name="applicantName"
                    onChange={(e) => dmsChange(e)}
                    value={addDmsData.applicantName}
                />
                <span style={{color:"red"}}>{errMsg.applicantName}</span>
              </Col>
              <Col>
                <label>DMS Code</label>
                <input
                  type="number"
                  name="dmsCode"
                  className="search-button dms-search mt-2"
                  placeholder="DMS Code..."
                  onChange={(e) => dmsChange(e)}
                  value={addDmsData.dmsCode || ""}
                />  
                <br/>
                <span style={{color:"red"}}>{errMsg.dmsCode}</span>
              </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            {isSubmit ? 'Loading...' : 'Submit' }
          </Button>
        </Modal.Footer>
      </Modal>
        </Layout>
      </MainLayout>
    </BaseUrl.Provider>
  );
};

export default DMS;